import React from "/vendor/react";
import PropTypes from "prop-types";

import { Box } from "/vendor/@material-ui/core";
import { NotFound, AppLayout } from "/lib/component/partial";

class NamespaceNotFoundView extends React.PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired,
  };

  render() {
    return (
      <AppLayout disableBreadcrumbs>
        <Box height="calc(100vh - 24px)" display="flex" alignItems="center">
          <NotFound>
            No namespaces have been assigned. Please contact an admin.
          </NotFound>
        </Box>
      </AppLayout>
    );
  }
}

export default NamespaceNotFoundView;
